export const DEFAULT_SCREEN_EVENTSLOG  = -4;
export const DEFAULT_SCREEN_CHART  = -2;
export const DEFAULT_SCREEN_MAP  = -1;
export const DEFAULT_SCREEN_HOME  = 0;
